export default "__VITE_ASSET__Bms7H_su__"